import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store";

interface NavigationState {
  [key: string]: any;
}

const LOCAL_STORAGE_KEY = "navigationState";

const loadFromLocalStorage = (): NavigationState => {
  try {
    const serializedState = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (serializedState === null) {
      return {};
    }
    const parsedState = JSON.parse(serializedState);
    if (parsedState && typeof parsedState === "object") {
      return parsedState as NavigationState;
    }
    return {};
  } catch (error) {
    console.error("Error loading navigation state from local storage:", error);
    return {};
  }
};

const initialState: NavigationState = loadFromLocalStorage();

const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setNavigationData: (state, action: PayloadAction<NavigationState>) => {
      const newState = { ...state, ...action.payload };
      // Save to local storage
      try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newState));
      } catch (error) {
        console.error("Error saving navigation state to local storage:", error);
      }
      return newState;
    },
    resetNavigationData: () => {
      // Clear local storage
      try {
        localStorage.removeItem(LOCAL_STORAGE_KEY);
      } catch (error) {
        console.error("Error clearing navigation state from local storage:", error);
      }
      return {};
    },
  },
});

export const { setNavigationData, resetNavigationData } = navigationSlice.actions;
export default navigationSlice.reducer;
export const selectNavigationData = (state: RootState) => state.navigation;